import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
const useFetch = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { t, i18n } = useTranslation();
  const fetchData = async (url) => {
    setError(false);
    try {
      const response = await fetch(
        `https://phplaravel-1177998-4901667.cloudwaysapps.com/api/${
          i18n.language === "ar" ? "ar" : "en"
        }/${url}`
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();
      setData(result);
      return result;
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, fetchData };
};

export default useFetch;
